import { Typography } from "@mui/material"
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispachToProps } from "../../../store/MapToProps";
import ProviderForm from "./ProviderForm";

const AddData = (props) => {
  const location = useLocation();

  return (
    <>
      <Typography
        variant="h4"
        noWrap
        component="div"
        sx={{ marginTop: '1em', marginBottom: '1.5em' }}
      >
        {`Add ${location.state.pageTitle}`}
      </Typography>
      <ProviderForm addProvider={props.addProvider} enableLoader={props.enableLoder} />
    </>
  );
}

export default connect(mapStateToProps, mapDispachToProps)(AddData);